import { Injectable } from '@angular/core';

type Amplitude = {
    push: (payload: object) => void;
};

type AmplitudeWindow = Window &
    typeof globalThis & {
        dataLayer?: Amplitude;
    };

@Injectable({
    providedIn: 'root',
})
export class AmplitudeAnalyticsService {
    public static sendEvent(payload: object): void {
        const amplitude = AmplitudeAnalyticsService.getAmplitude();

        if (!amplitude) {
            console.warn('Amplitude SDK is not loaded.');
            return;
        }

        try {
            amplitude.push(payload);
            console.log(`Amplitude event sent: ${JSON.stringify(payload)}`);
        } catch (error) {
            console.error('Amplitude error', error);
        }
    }

    private static isBrowser(): boolean {
        return typeof window !== 'undefined' && typeof document !== 'undefined';
    }

    private static getAmplitude(): Amplitude | null {
        if (!AmplitudeAnalyticsService.isBrowser()) {
            return null;
        }

        if (!('dataLayer' in window)) {
            return null;
        }

        const amplitude = (window as AmplitudeWindow).dataLayer;
        if ('push' in amplitude && typeof amplitude.push === 'function') {
            return amplitude;
        }

        return null;
    }
}
